module.exports = {
    messages: {
        de:
        {
            bundle: {
                bundle: "Konvolut",
                empty: "Das gewählte Konvolut enthält keine Seiten",
                for: "zu",
                notAvailable: "[nicht verfügbar]"
            }
        },
        en:
        {
            bundle: {
                bundle: "Set",
                empty: "The selected bundle does not contain any pages",
                for: "for",
                notAvailable: "[not available]"
            }
        },
        fr:
        {
            bundle: {
                bundle: "Konvolut",
                empty: "Le konvolut sélectionnée ne contient aucune page",
                for: "de",
                notAvailable: "[indisponible]"
            }
        }
    }
}
